import app from '../../common/app';
import Component from '../Component';
import Alert from './Alert';
import Button from './Button';
import classList from '../utils/classList';
/**
 * The `Modal` component displays a modal dialog, wrapped in a form. Subclasses
 * should implement the `className`, `title`, and `content` methods.
 */
export default class Modal extends Component {
  /**
   * Can the model be dismissed with a close button (X)?
   *
   * If `false`, no close button is shown.
   */
  static isDismissibleViaCloseButton = true;
  /**
   * Can the modal be dismissed by pressing the Esc key on a keyboard?
   */
  static isDismissibleViaEscKey = true;
  /**
   * Can the modal be dismissed via a click on the backdrop.
   */
  static isDismissibleViaBackdropClick = true;
  static get dismissibleOptions() {
    return {
      viaCloseButton: this.isDismissibleViaCloseButton,
      viaEscKey: this.isDismissibleViaEscKey,
      viaBackdropClick: this.isDismissibleViaBackdropClick
    };
  }
  loading = false;

  /**
   * Attributes for an alert component to show below the header.
   */
  alertAttrs = null;
  oncreate(vnode) {
    super.oncreate(vnode);
    this.attrs.animateShow(() => this.onready());
  }
  onbeforeremove(vnode) {
    super.onbeforeremove(vnode);

    // If the global modal state currently contains a modal,
    // we've just opened up a new one, and accordingly,
    // we don't need to show a hide animation.
    if (!this.attrs.state.modal) {
      // Here, we ensure that the animation has time to complete.
      // See https://mithril.js.org/lifecycle-methods.html#onbeforeremove
      // Bootstrap's Modal.TRANSITION_DURATION is 300 ms.
      return new Promise(resolve => setTimeout(resolve, 300));
    }
  }
  view() {
    if (this.alertAttrs) {
      this.alertAttrs.dismissible = false;
    }
    return m("div", {
      className: classList('Modal modal-dialog fade', this.className())
    }, m("div", {
      className: "Modal-content"
    }, this.dismissibleOptions.viaCloseButton && m("div", {
      className: "Modal-close App-backControl"
    }, m(Button, {
      icon: "fas fa-times",
      onclick: () => this.hide(),
      className: "Button Button--icon Button--link",
      "aria-label": app.translator.trans('core.lib.modal.close')
    })), this.wrapper(this.inner())));
  }
  wrapper(children) {
    return m('[', null, children);
  }
  inner() {
    return m('[', null, m("div", {
      className: "Modal-header"
    }, m("h3", {
      className: "App-titleControl App-titleControl--text"
    }, this.title())), !!this.alertAttrs && m("div", {
      className: "Modal-alert"
    }, m(Alert, this.alertAttrs)), this.content());
  }

  /**
   * Get the class name to apply to the modal.
   */

  /**
   * Get the title of the modal dialog.
   */

  /**
   * Get the content of the modal.
   */

  /**
   * Callback executed when the modal is shown and ready to be interacted with.
   */
  onready() {
    // ...
  }

  /**
   * Hides the modal.
   */
  hide() {
    this.attrs.animateHide();
  }

  /**
   * Sets `loading` to false and triggers a redraw.
   */
  loaded() {
    this.loading = false;
    m.redraw();
  }
  get dismissibleOptions() {
    return this.constructor.dismissibleOptions;
  }
}
flarum.reg.add('core', 'common/components/Modal', Modal);